import gql from 'graphql-tag';

export const GET_USER_ZONE_ASSIGNMENTS_BY_USER_EMAIL = gql`
  query GetUserZoneAssignmentsByUserEmail($userEmail: String!) {
    GetUserZoneAssignmentsByUserEmail(UserEmail: $userEmail) {
      UserId
      UserEmail
      FirstName
      LastName
      Zones {
        Id
        Name
        HBGFacilityNumber
        Stations {
          Id
          Name
          HBGFacilityNumber
          OrderOfExecution
          InspectionTasks {
            Id
            Name
            IsRequired
            ResultSetName
            AllowedResults {
              Id
              ResultValue
            }
          }
        }
      }
    }
  }
`;

export const GET_INSPECTION_EXECUTION_DATA_BY_ID = gql`
query GetInspectionExecutionData($id: ID!) {
  GetInspectionExecutionData(Id: $id) {
    HbgInspectionId
    HBGInspectionStatus
    HBGInspectionContexts {
      Key
      Value
    }
    ZoneId
    ZoneName
    Sections {
      SectionId
      SectionName
      Stations {
        Id
        Name
        HBGFacilityNumber
        TaskExecutions {
          Id
          PerformedByQTUserId
          InjectedByQTUserId
          FromStationId
          TaskStatus
          TaskStatusId
          AssignedStationId
          SectionId
          ResultValue
          TaskId
          TaskName
          DepartmentTypes
          OrderOfPresentation
        }
        DefectedTasks{
          Id
          SerialNumber
          TaskExecutionId
          TaskName
          LocationId
          DepartmentId
          StatusId
          ClosedByQTUserId
          Description
          DefectQuantity
          StationId
          AttachmentLocationKeys
          AttachmentType
        }
      }
    }
    CompletedInspections{
      SignedOffByQTUserId
      ZoneId
      SectionId
    }
  }
}
`;
